app.factory('dictionaryModel', ['$rootScope', '$q', 'baseModel', 'dictionaryService',
    function($rootScope, $q, baseModel, dictionaryService) {

	    function DictionaryModel() {

		   	this.getDictionaryElementsDataPage = function(code, criteria) {
		   		return dictionaryService.getDictionaryElementsDataPage(code, criteria).then(
		   			function (dataPage) {
		   				$rootScope.$broadcast(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, dataPage, code, criteria.additionalCriteriaField);
						return dataPage;
		   			},
		   			function(error) {
		   				$rootScope.$broadcast(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.ERROR, error);
						$q.reject(error);
		   			}
		   		);
		    };

			this.saveDictionaryElement = function(dictionaryCode, dictionaryElement) {
				dictionaryService.saveDictionaryElement(dictionaryCode, dictionaryElement).then(
					function (dictionaryElement) {
						$rootScope.$broadcast(Event.DICTIONARY.SAVE_DICTIONARY_ELEMENT.SUCCESS, dictionaryElement);
						baseModel.broadcastOperationSucceeded();
					},
					function(error) {
						$rootScope.$broadcast(Event.DICTIONARY.SAVE_DICTIONARY_ELEMENT.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				);
			};

			this.updateDictionaryElement = function(dictionaryCode, dictionaryElement) {
				dictionaryService.updateDictionaryElement(dictionaryCode, dictionaryElement).then(
					function (dictionaryElement) {
						$rootScope.$broadcast(Event.DICTIONARY.UPDATE_DICTIONARY_ELEMENT.SUCCESS, dictionaryElement);
						baseModel.broadcastOperationSucceeded();
					},
					function(error) {
						$rootScope.$broadcast(Event.DICTIONARY.UPDATE_DICTIONARY_ELEMENT.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				);
			};

			this.deleteDictionaryElement = function(dictionaryCode, dictionaryElement) {
				dictionaryService.deleteDictionaryElement(dictionaryCode, dictionaryElement).then(
					function (dictionaryElement) {
						$rootScope.$broadcast(Event.DICTIONARY.DELETE_DICTIONARY_ELEMENT.SUCCESS, dictionaryElement);
						baseModel.broadcastOperationSucceeded();
					},
					function(error) {
						$rootScope.$broadcast(Event.DICTIONARY.DELETE_DICTIONARY_ELEMENT.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				);
			};

			this.getOrganizationalUnits = function(code, criteria) {
				dictionaryService.getOrganizationalUnits(criteria).then(
					function (dataPage) {
						$rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_ORGANIZATION_UNITS.SUCCESS, dataPage, code);
					},
					function(error) {
						$rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_ORGANIZATION_UNITS.ERROR, error);
					}
				);
			};
	
	    }
	
	    return new DictionaryModel();
	}
]);
